import { z } from 'zod';
// WebRTC signaling messages. Routed by the relay between the paired host
// and viewer sockets for a given sessionId. Each message carries the raw
// SDP string or ICE candidate verbatim - the relay does not inspect or
// transform the payload, it just forwards.
//
// Phase 1 use: host offers an audio-receiving channel to the viewer so
// the viewer can hear host system audio alongside the H.264 video stream.
// Later phases add admin mic + admin screen + admin webcam using the same
// three message types - more streams, same signaling.
export const WebRtcOffer = z.object({
    sessionId: z.number().int().nonnegative(),
    sdp: z.string().min(1),
});
export const WebRtcAnswer = z.object({
    sessionId: z.number().int().nonnegative(),
    sdp: z.string().min(1),
});
export const WebRtcIceCandidate = z.object({
    sessionId: z.number().int().nonnegative(),
    // The ICE candidate string, exactly as produced by RTCIceCandidate.candidate.
    // May be empty when the ICE agent is signalling end-of-candidates.
    candidate: z.string(),
    // null when the candidate is end-of-candidates or m-line-less (datachannel-only
    // sessions). We keep both lookup keys so either implementation style works.
    sdpMid: z.string().nullable(),
    sdpMLineIndex: z.number().int().nonnegative().nullable(),
});
//# sourceMappingURL=webrtc.js.map